import React, { useState, useRef, useEffect } from "react";
import useAuthentication from "../../../hooks/userAuthenticatication/useAuthentication";
import { getTimeZoneName, getTimeZoneOffsetFormatted } from "../../../services/untils/formatDate";
import { useAuthenticationContext } from "../../../services/slices/AuthenticationSlicer";
import LocationService from '../../../services/API/locationService';
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosConfig from "../../../services/axiosConfig.js";
import CommonService from "../../../services/API/commonService";
// import firebase from "firebase/app";
// import "firebase/messaging";
// import { messaging, getToken } from "../../../config/firebaseConfig.js";

const StepOTC = ({ handleNextEvent, formData, setPersonalInfo }) => {
  const [otp, setOtp] = useState(new Array(6).fill(formData.otp));
  const inputRefs = useRef([]);
  const [focusIndex, setFocusIndex] = useState();
  const [tokenFCM, setTokenFCM] = useState(null);
  const [currentUserToken, setCurrentUserToken] = useState(null);
  const [searchParams] = useSearchParams();
  const [hiddenIndex, setHiddenIndex] = useState(null);
  const { dispatchSignInWithPhoneVerify, dispatchResendcode, dispatchSignInWithEmailLinkVerify } = useAuthentication();
  const [ip, setIp] = useState('');
  const navigate = useNavigate();
  const { login, redirectPath } = useAuthenticationContext();
  let isCallUpdate = false;
  const [locationData, setLocationData] = useState({
    ip: '',
    city: '',
    region: '',
    country: '',
    latitude: '',
    longitude: '',
  });
  useEffect(() => {
    formData['countryCodes'] = `${formData?.countryCodes ? formData?.countryCodes : '+1'}`
    formData['mobileNumber'] = formData?.mobileNumber;
    if (formData?.otp) {
      setOtp(formData?.otp);
    }
    fetchIp();
    // generateTokenFCM();
  }, []);
  const handleInputChange = (e, index) => {
    const { value } = e.target;
    if (value.length === 1 && /^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      // Move to the next input if available
      if (index < 5) {
        inputRefs.current[index + 1].focus();
      }
      // let isValidForm = newOtp?.find(x => x === '')?.length === 0;
      let hasValidValue = newOtp.filter(item => item === '' || item === undefined)?.length === 0
      formData.otp = newOtp;
      if (hasValidValue) {
        setPersonalInfo();
        handleOTCverification();
      }
    } else if (value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      formData.otp = newOtp;
    }
  };

  const handlePaste = (e) => {
    e.preventDefault(); // Prevent default paste behavior
    const pasteData = e.clipboardData.getData("text"); // Get pasted text
    const digits = pasteData.match(/\d/g); // Extract only digits
  
    if (!digits) return;
  
    // Limit to the length of the OTP array
    const newOtp = [...otp];
    digits.slice(0, newOtp.length).forEach((digit, index) => {
      newOtp[index] = digit;
    });
  
    setOtp(newOtp);
    // formData.otp = newOtp;
    let hasValidValue = newOtp.filter(item => item === '' || item === undefined)?.length === 0
    formData.otp = newOtp;
    if (hasValidValue) {
      setPersonalInfo();
      handleOTCverification();
    }
    // Move focus to the last filled input
    const nextIndex = digits.length < newOtp.length ? digits.length : newOtp.length - 1;
    inputRefs.current[nextIndex]?.focus();
  };
  

  // const handleEmailOTCVerification = async () => {
  //   try {
  //     const timeZoneOffset = getTimeZoneOffsetFormatted();
  //     const timeZoneName = getTimeZoneName();
  //     const oTPRequest = {
  //       "emailAddress": `${formData.email}`,
  //       // "otp": formData.otp.join(""),
  //       "session": formData.session,
  //       "ipAddress": locationData.ip,
  //       "deviceId": "string",
  //       "timeZoneOffset": timeZoneOffset,
  //       "timeZoneName": timeZoneName,
  //       "token": formData?.magicToken
  //     }
  //     const res = await dispatchSignInWithEmailLinkVerify(oTPRequest);
  //     if (res && res?.statusCode === 200) {
  //       if (!isCallUpdate) {
  //         isCallUpdate = true;
  //         updateDeviceTokenRepo(tokenFCM, res.result.token);
  //       }
  //       if (res?.result?.email !== '' &&
  //         res?.result?.first_name !== '' &&
  //         res?.result?.last_name !== '' &&
  //         res?.result?.fkGenderId !== '') {
  //         localStorage.removeItem('phoneNumber');
  //         localStorage.removeItem('emailAddress');
  //         if (searchParams.get('callback')) {
  //           navigate(searchParams.get('callback'));
  //         } else {
  //           navigate("/landing");
  //         }
  //         // navigate(`/landing`);
  //       } else {
  //         if (res?.result?.email && res?.result?.email !== '') {
  //           handleNextEvent(3); // Proceed to next step if needed
  //           navigate(`/personalDetails?${handleQueryParams(3)}`);
  //         } else {
  //           handleNextEvent(2); // Proceed to next step if needed
  //           navigate(`/personalDetails?${handleQueryParams(2)}`);
  //         }
  //       }
  //     } else {
  //       console.warn("Login unsuccessful", res.message || "Unauthorized access");
  //     }

  //   } catch (error) {
  //     console.error("Login failed: ", error);
  //   }
  // }
  const handleOTCverification = async () => {
    try {
      const timeZoneOffset = getTimeZoneOffsetFormatted();
      const timeZoneName = getTimeZoneName();
      const oTPRequest = {
        "phoneNumber": `${formData.countryCodes ? formData.countryCodes : '+1'}${formData.mobileNumber}`,
        "otp": formData.otp.join(""),
        "session": formData.session,
        "ipAddress": locationData.ip,
        "deviceId": "string",
        "timeZoneOffset": timeZoneOffset,
        "timeZoneName": timeZoneName
      }
      const res = await dispatchSignInWithPhoneVerify(oTPRequest);
      if (res && res?.statusCode === 200) {
        // if (!isCallUpdate) {
        //   isCallUpdate = true;
        //   updateDeviceTokenRepo(tokenFCM, res.result.token);
        // }
        if (res?.result?.email !== '' &&
          res?.result?.first_name !== '' &&
          res?.result?.last_name !== '' &&
          res?.result?.fkGenderId !== '') {
          localStorage.removeItem('phoneNumber');
          if (searchParams.get('callback')) {
            navigate(searchParams.get('callback'));
          } else {
            navigate("/landing");
          }
          // navigate(`/landing`);
        } else {
          if (res?.result?.email && res?.result?.email !== '') {
            handleNextEvent(3); // Proceed to next step if needed
            navigate(`/personalDetails?${handleQueryParams(3)}`);
          } else {
            handleNextEvent(2); // Proceed to next step if needed
            navigate(`/personalDetails?${handleQueryParams(2)}`);
          }
        }
      } else {
        console.warn("Login unsuccessful", res.message || "Unauthorized access");
      }

    } catch (error) {
      console.error("Login failed: ", error);
    }
  }

  // Generate FCM Token
  // const generateTokenFCM = async () => {
  //   try {
  //     // const messaging = firebase.messaging();
  //     const permission = await Notification.requestPermission();
  //     let vapidKey = 'BDEh-AP9gUACx7gjmL4lO8rmbB-uGSmwfKAcUcioGxvIJ8sOOccApbCq5KLA979v8Sjdst6txBG0JjP0q7Yg630';

  //     if (permission === "granted") {
  //       // Register service worker
  //       if ('serviceWorker' in navigator) {
  //         navigator.serviceWorker
  //           .register(`/firebase-messaging-sw.js`)
  //           .then((registration) => {
  //             console.log('Service Worker registered with scope: ', registration.scope);
  //             // Request FCM token
  //             getToken(messaging, { vapidKey: vapidKey, serviceWorkerRegistration: registration })
  //               .then((currentToken) => {
  //                 if (currentToken) {
  //                   setTokenFCM(currentToken);
  //                   console.log('FCM Token:', currentToken);
  //                 } else {
  //                   console.log('No registration token available. Request permission to generate one.');
  //                 }
  //               })
  //               .catch((err) => {
  //                 console.error('An error occurred while retrieving token: ', err);
  //               });
  //           })
  //           .catch((err) => {
  //             console.error('Service Worker registration failed: ', err);
  //           });
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error generating FCM token:", error);
  //   }
  // };

  // Update Device Token API Call
  // const updateDeviceTokenRepo = async (tokenFCM, token) => {
  //   try {
  //     const response = await CommonService.updateDeviceTokenRepo(tokenFCM, token);
  //     if (response.status === 200) {
  //       console.log("Device token updated successfully.");
  //       return true;
  //     }
  //   } catch (error) {
  //     console.error("Error updating device token:", error.message);
  //     // Track event (mocked here)
  //     // trackEvent("API Error", error.message);
  //     return null;
  //   }
  // };

  const handleQueryParams = (currentStep) => {
    return searchParams.get('callback') ? `step=${currentStep}&callback=${searchParams.get('callback')}` : `step=${currentStep}`;
  }
  const fetchIp = async () => {
    const res = await LocationService.getCurrentLocation();
    if (res && res.query) {
      setLocationData({
        ip: res.query,
        city: res.city,
        region: res.regionName,
        country: res.country,
        lat: res.lat,
        lon: res.lon,
      });
    }
  };

  const handleKeyDown = (e, index) => {
    // if (e.key === "Backspace" && otp[index] === "" && index > 0) {
    //   // Move to the previous input
    //   setFocusIndex(index)
    //   inputRefs.current[index - 1].focus();
    // }
  };

  /*const handleSubmit = (e) => {
    e.preventDefault();
    handleNextEvent(3);
    // You can add your verification logic here
  };*/

  const handleFocus = (index) => {
    setFocusIndex(index);
  };

  const handleBlur = () => {
    setFocusIndex(null);
  };

  const handleClick = (index) => {
    setHiddenIndex(index);
    setFocusIndex(index);
    // setHiddenIndices((prev) =>
    //   prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    // );
  };

  const handleResendCode = async () => {
    try {
      const oTPRequest = { phoneNumber: `${formData.countryCodes ? formData.countryCodes : '+1'}${formData.mobileNumber}` };

      const res = await dispatchResendcode(oTPRequest);
      // const res = await AuthenticationService.loginUser(credentials);
      if (res && res.code === 200) { // Check if response code is 200 (successful)
        formData['session'] = res?.result?.session;
        // handleNext(2); // Proceed to next step if needed
      } else {
        console.warn("Login unsuccessful", res.message || "Unauthorized access");
      }

    } catch (error) {
      console.error("Login failed: ", error);
    }
  }
  const handleSigninwithemail = () => {
    handleNextEvent(0);
    localStorage.setItem('isEmail', 'true');
    // navigate(`/personalDetails?step=${0}&isEmail=${true}}`);
  }
  return (
    <div className="otp-container">

      <>
        <h1 className="title">Verify your mobile number</h1>
        <p className="sub-title">Enter the code sent to (•••) ••• •• {formData.mobileNumber.slice(-2)}</p>

        <form >
          <div className="otp-inputs" >
            {otp.map((digit, index) => (
              <React.Fragment key={index}>
                <div className={focusIndex === index ? 'otc-input selected' : 'otc-input'} key={index}>
                  <input
                    key={index}
                    type={'text'}
                    maxLength="1"
                    className={'otp-input active'}
                    value={digit}
                    onChange={(e) => handleInputChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={() => handleFocus(index)}
                    onBlur={handleBlur}
                    ref={(el) => (inputRefs.current[index] = el)}
                    onPaste={handlePaste}
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
          <p className="resend-text sub-title mb-2">
            Didn't receive the text? <a href="#" onClick={handleResendCode}>Resend code</a>
          </p>
          <p className="resend-text sub-title mt-0 ">
            Trouble signing in? <a href="#" onClick={handleSigninwithemail}>Sign in with email</a>
          </p>

          {otp?.length === 6 && (
            <></>
            /*<Button
             btnClass={'btn-primary'}
             btnType={'submit'}
             btnName={'Verify'}
             onClick={handleSubmit}
             isDisabled={true}
           />*/
          )}
        </form>
      </>
    </div>
  );
};

export default StepOTC;
